import styled from 'styled-components';
import { theme } from '@mtsbank/ui-kit';
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  padding-bottom: 16px;

  &:focus {
    outline: none;
  }

  @media (min-width: ${theme.breakpoints.sm}px) {
    padding-bottom: 0;
  }
`;
export const Transform = styled.div<{
  value: number;
  units: '%' | 'px';
}>`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  transform: translate3d(-${({
  value,
  units
}) => `${value}${units}`}, 0px, 0px);
  transition-duration: 350ms;
`;
export const Slide = styled.div`
  min-width: 100%;
  position: relative;
  overflow: hidden;
`;
export const CarouselSwipe = styled.div`
  position: relative;
  height: 100%;
`;